import React, { ReactElement } from "react";
import MainBanner from "@components/hearingaidoffers/mainBanner";
import HearingaidoffersWrapper from "@components/layouts/hearingAidOffersWrapper";
import { GetServerSideProps } from "next";
import dynamic from "next/dynamic";
import { getPageProps } from "@services/initial-calls";
import { useDomainContext } from "@hooks/useDomainContext";
import OffersList from "@components/shared/offersList";

const WhyUs = dynamic(() => import("@components/hearingaidoffers/whyUs"));

export default function HearingAidOffersHome(): ReactElement {
    const { domain } = useDomainContext();

    return (
        <HearingaidoffersWrapper>
            <MainBanner />
            <section>
                <OffersList offers={domain?.defaultOffers} />
            </section>
            <WhyUs />
        </HearingaidoffersWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home");
};
